import React, { useMemo, useState } from 'react';
import { CREATIVE_FONTS, CREATIVE_FONT_CATEGORIES, searchCreativeFonts } from '@/data/creativeFonts';

export default function CreativeFontLibrary({ selectedId, onSelect }) {
  const [q, setQ] = useState('');
  const [cat, setCat] = useState('All');
  const filtered = useMemo(() => {
    let list = searchCreativeFonts(q);
    if (cat !== 'All') list = list.filter(f => f.cat === cat);
    return list;
  }, [q, cat]);

  return (
    <div className="space-y-3" data-testid="creative-font-library">
      <div className="flex flex-wrap items-center justify-between gap-2">
        <div className="eyebrow">Creative & Character-Inspired Lettering · {CREATIVE_FONTS.length} references</div>
        <div className="text-[10px] text-zinc-500">Reference-only prompt direction — not downloadable font files.</div>
      </div>
      <div className="flex flex-wrap gap-2">
        <input data-testid="creative-font-search" value={q} onChange={(e) => setQ(e.target.value)} placeholder="Search by name, franchise, mood, era, material…" className="flex-1 min-w-[220px] bg-zinc-950 border border-zinc-800 rounded-full px-3 py-1.5 text-xs" />
        <select data-testid="creative-font-cat" value={cat} onChange={(e) => setCat(e.target.value)} className="bg-zinc-950 border border-zinc-800 rounded-full px-3 py-1.5 text-xs">
          <option value="All">All Categories</option>
          {CREATIVE_FONT_CATEGORIES.map(c => <option key={c} value={c}>{c}</option>)}
        </select>
      </div>
      {filtered.length === 0 ? (
        <p className="text-xs text-zinc-500">No matches. You can still type any lettering direction below.</p>
      ) : (
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-2 max-h-[420px] overflow-y-auto scrollbar-thin pr-1">
          {filtered.map(f => {
            const active = selectedId === f.id;
            return (
              <button
                key={f.id}
                data-testid={`cf-${f.id}`}
                onClick={() => onSelect(active ? null : f)}
                className={`text-left rounded-xl px-3 py-3 text-xs transition-colors ${active ? 'bg-pink-500/20 border border-pink-500 text-white' : 'chrome-border chrome-hover bg-zinc-950 text-zinc-300'}`}
              >
                <div className="text-[11px] uppercase tracking-widest text-zinc-500 mb-1">{f.cat}</div>
                <div className="text-sm text-white mb-1">{f.name}</div>
                <div className="text-[11px] text-zinc-400 leading-snug line-clamp-3">{f.description}</div>
                <div className="flex flex-wrap gap-1 mt-2">
                  {(f.tags || []).slice(0, 4).map(t => <span key={t} className="text-[9px] uppercase tracking-widest text-zinc-500">#{t}</span>)}
                </div>
              </button>
            );
          })}
        </div>
      )}
    </div>
  );
}
